module.exports = __webpack_public_path__ + "media/src/images/icons/minus-81cca2c2e0bb368392f45d91788562b0.svg";